import request from '../../utils/request'

const preFix = '/system/users';

export const reqListSysUsers = (data) => {
    return request({
        url: preFix + '/list',
        method: 'POST',
        data: data
    })
}
export const reqInsertSysUsers = (data) => {
    return request({
        url: preFix + '/insert',
        method: 'POST',
        data: data
    })
}
export const reqUpdateSysUsers = (data) => {
    return request({
        url: preFix + '/update',
        method: 'POST',
        data: data
    })
}
export const reqDeleteSysUsersById = (data) => {
    return request({
        url: preFix + '/delete',
        method: 'get',
        params: data
    })
}
export const reqGetSysUsersById = (data) => {
    return request({
        url: preFix + '/detail',
        method: 'get',
        params: data
    })
}
